import React from "react";
import axios from '../../config/axiosClient';

import Config from "../../config/Config.js";
import ProjectCard from "./ProjectCard";
import SweetLoadingSpinner from '../eyeCandy/SweetLoadingSpinner';


class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project_list: [],
      loading: true,
      loadingMore: false,
      allFetched: [],  // all results from API (for shuffle mode)
      shownIds: new Set(),
      hasMore: false,
    };
  }

  componentDidMount() {
    const limit = this.props.limit || 12;
    const ordering = this.props.ordering || '';
    let url = `${Config().baseUrl}?publish=${this.props.publish}&limit=${limit}`;
    if (ordering) url += `&ordering=${ordering}`;

    // If shuffling, fetch more than needed so the random sample is interesting
    const fetchLimit = this.props.shuffle ? Math.max(limit * 4, 40) : limit;
    const fetchUrl = this.props.shuffle
      ? `${Config().baseUrl}?publish=${this.props.publish}&limit=${fetchLimit}`
      : url;

    axios.get(fetchUrl)
      .then(res => {
        let results = res.data.results || [];
        const totalCount = res.data.count || results.length;

        if (this.props.shuffle) {
          // Fisher-Yates shuffle, then take the requested limit
          for (let i = results.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [results[i], results[j]] = [results[j], results[i]];
          }
          const shown = results.slice(0, limit);
          const shownIds = new Set(shown.map(p => p.id));
          this.setState({
            project_list: shown,
            allFetched: results,
            shownIds,
            hasMore: results.length > limit || totalCount > fetchLimit,
            loading: false,
            nextUrl: null,
          });
        } else {
          const nextUrl = res.data.next?.replace('http://', 'https://') || null;
          this.setState({
            project_list: results,
            hasMore: !!nextUrl,
            nextUrl,
            loading: false,
          });
        }
      })
      .catch(err => {
        console.error('ProjectList Load Error:', err);
        this.setState({
          project_list: [],
          loading: false
        });
      });
  }

  loadMore = () => {
    if (this.state.loadingMore) return;
    const limit = this.props.limit || 12;

    if (this.props.shuffle) {
      // Try to pick from already-fetched but not yet shown
      const { allFetched, shownIds } = this.state;
      const remaining = allFetched.filter(p => !shownIds.has(p.id));

      if (remaining.length >= limit) {
        // Shuffle remaining and take next batch
        for (let i = remaining.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
        }
        const next = remaining.slice(0, limit);
        const newShownIds = new Set(shownIds);
        next.forEach(p => newShownIds.add(p.id));
        this.setState({
          project_list: [...this.state.project_list, ...next],
          shownIds: newShownIds,
          hasMore: remaining.length > limit,
        });
      } else {
        // Fetch more from API
        this.setState({ loadingMore: true });
        const offset = allFetched.length;
        const fetchUrl = `${Config().baseUrl}?publish=${this.props.publish}&limit=40&offset=${offset}`;
        axios.get(fetchUrl)
          .then(res => {
            const newResults = (res.data.results || []).filter(p => !shownIds.has(p.id));
            const combined = [...remaining, ...newResults];
            // Shuffle
            for (let i = combined.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [combined[i], combined[j]] = [combined[j], combined[i]];
            }
            const next = combined.slice(0, limit);
            const newShownIds = new Set(shownIds);
            next.forEach(p => newShownIds.add(p.id));
            const newAll = [...allFetched, ...(res.data.results || [])];
            this.setState({
              project_list: [...this.state.project_list, ...next],
              allFetched: newAll,
              shownIds: newShownIds,
              hasMore: combined.length > limit || (res.data.next !== null),
              loadingMore: false,
            });
          })
          .catch(err => {
            console.error('ProjectList loadMore error:', err);
            this.setState({ loadingMore: false });
          });
      }
    } else {
      // Standard pagination
      const { nextUrl } = this.state;
      if (!nextUrl) return;
      this.setState({ loadingMore: true });
      axios.get(nextUrl)
        .then(res => {
          const results = res.data.results || [];
          const next = res.data.next?.replace('http://', 'https://') || null;
          this.setState({
            project_list: [...this.state.project_list, ...results],
            nextUrl: next,
            hasMore: !!next,
            loadingMore: false,
          });
        })
        .catch(err => {
          console.error('ProjectList loadMore error:', err);
          this.setState({ loadingMore: false });
        });
    }
  }

  render() {
    return (
      <div>
        <SweetLoadingSpinner loadingState={this.state.loading} />
        <div className="row">
          {this.state.project_list.map(project => {
            return <ProjectCard project={project} key={project.id} colClass="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-xs-12" />;
          })}
        </div>
        {this.state.hasMore && !this.state.loading && (
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <button
              type="button"
              onClick={this.loadMore}
              disabled={this.state.loadingMore}
              style={{
                fontSize: 13, fontWeight: 600, padding: '8px 24px',
                borderRadius: 6, border: '1px solid var(--border)',
                background: 'var(--surface)', color: 'var(--ink)',
                cursor: this.state.loadingMore ? 'not-allowed' : 'pointer',
                opacity: this.state.loadingMore ? 0.6 : 1,
              }}
            >
              {this.state.loadingMore ? 'Loading...' : 'Load more'}
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default ProjectList;
